import PrintProductConfiguratorPreviewPane from './PrintProductConfiguratorPreviewPane';

export default PrintProductConfiguratorPreviewPane;
